import * as Sentry from '@sentry/react'

// Initialise Sentry only when a DSN is configured. The app must keep
// working unmodified in dev / on PR previews where the DSN is absent —
// Sentry stays silent and reports nothing instead of throwing.
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    release: import.meta.env.VITE_GIT_SHA || 'unknown',
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    // Keep noise out of the dashboard.
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'Non-Error promise rejection captured',
      // Common browser-extension noise
      /extension\//i,
      /chrome-extension/i,
      /safari-extension/i,
      /moz-extension/i,
    ],
    denyUrls: [
      /chrome-extension:\/\//i,
      /safari-extension:\/\//i,
      /moz-extension:\/\//i,
    ],
    // Sample everything at 100% — volumes are tiny on v1.
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  })
}

export const SentryErrorBoundary = Sentry.ErrorBoundary
export { Sentry }
